import { fork, all } from 'redux-saga/effects';

import appSaga from './app';
import memberSaga from './member';
import serviceSaga from './service';
import activitySaga from './activity';
import mallSaga from './mall';
import ownSaga from './own';
import gameSaga from './game';
import happygoSaga from './happygo';
import homeSaga from './home';
import paySaga from './pay';
import noticeSaga from './notice';
import weibansSaga from './weiban';
export default function* root() {
  yield all([
    fork(appSaga),
    fork(memberSaga),
    fork(serviceSaga),
    fork(activitySaga),
    fork(mallSaga),
    fork(ownSaga),
    fork(gameSaga),
    fork(happygoSaga),
    fork(homeSaga),
    fork(paySaga),
    fork(noticeSaga),
    fork(weibansSaga)
  ]);
}
